"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { MovieActivityContext } from "src/components/film/filmwebid/MovieActivityContextTypes";
import useMovieActivity from "src/lib/filmwebid/useMovieActivity";
import type { IFilmwebIdMovieIdentifier } from "src/lib/filmwebid/useMovieIdentifier";

//#region [Props]
type MovieActivityWrapperProps = {
  movieIdentifier: IFilmwebIdMovieIdentifier | null;
  children: React.ReactNode;
};
//#endregion

//#region [Component]
export function MovieActivityWrapper(t0) {
  const $ = _c(8);
  const {
    movieIdentifier,
    children
  } = t0;
  const [activity, activityUpdater, isLoading, optimisticUpdater] = useMovieActivity(movieIdentifier);
  let t1;
  if ($[0] !== activity || $[1] !== activityUpdater || $[2] !== isLoading || $[3] !== optimisticUpdater) {
    t1 = {
      activity,
      activityUpdater,
      isLoading,
      optimisticUpdater
    };
    $[0] = activity;
    $[1] = activityUpdater;
    $[2] = isLoading;
    $[3] = optimisticUpdater;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children || $[6] !== t1) {
    t2 = <MovieActivityContext.Provider value={t1}>{children}</MovieActivityContext.Provider>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
//#endregion

//#region [Other]
//#endregion

//#region [Styles]

//#endregion